import { defineServerNegotiator } from "../helpers/defineServerNegotiator.js";
import {
  defaultLanguageNoPrefix,
  defaultLangcode,
  prefixToLangcode
} from "#nuxt-language-negotiation/config";
import { getQuery } from "h3";
function getActualPath(event) {
  if (event.path.startsWith("/__nuxt_error")) {
    const url = getQuery(event).url;
    if (typeof url === "string") {
      return url;
    }
  }
  return event.path;
}
export default defineServerNegotiator(() => {
  return {
    negotiate(event) {
      const path = getActualPath(event);
      const matches = /\/([^/]+)/.exec(path);
      const prefix = matches?.[1];
      if (prefix) {
        const langcode = prefixToLangcode[prefix];
        if (langcode) {
          return langcode;
        }
      }
      if (defaultLanguageNoPrefix) {
        return defaultLangcode;
      }
    }
  };
});
